import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { ReactComponent as EditSVG } from "assets/images/edit-outline.svg";
import { ReactComponent as ShareSVG } from "assets/images/share.svg";
import { ReactComponent as DeleteSVG } from "assets/images/delete-outline.svg";
import { ReactComponent as DownloadSVG } from "assets/images/download.svg";

export const PlaylistMenu: FC = () => {
  const { playlistMenu } = useShallowPickSelector("app", ["playlistMenu"]);
  const { user } = useShallowPickSelector("currentUser", ["user"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const onClose = () => {
    dispatch(
      appActions.setPlaylistMenu({
        isOpen: false,
        playlist: null,
        isEditable: false,
      })
    );
  };

  const onClickDownload: MouseEventHandler = () => {
    //trackMenu.track
  };

  const onClickShare: MouseEventHandler = () => {
    //trackMenu.track
  };

  const onClickEditPlaylist: MouseEventHandler = () => {
    if (!user || !playlistMenu.playlist) return;
    dispatch(
      appActions.setEditPlaylistMenu({
        isOpen: true,
        playlist: playlistMenu.playlist,
      })
    );
  };

  const onClickRemovePlaylist: MouseEventHandler = () => {
    if (!user || !playlistMenu.playlist) return;
    dispatch(
      appActions.setPlaylistRemoveConfirmationMenu({
        isOpen: true,
        playlist: playlistMenu.playlist,
      })
    );
  };

  return (
    <BottomSheet
      title={"گزینه‌ها"}
      isOpen={playlistMenu.isOpen}
      onClose={onClose}
      items={[
        /*
        {
          text: "دانلود همه",
          icon: <DownloadSVG />,
          onClick: onClickDownload,
        },
        {
          text: "اشتراک‌گذاری",
          icon: <ShareSVG />,
          onClick: onClickShare,
        },
        */
        playlistMenu.isEditable
          ? {
              text: "ویرایش پلی‌لیست",
              icon: <EditSVG />,
              onClick: onClickEditPlaylist,
            }
          : null,
        playlistMenu.isEditable
          ? {
              text: "حذف پلی‌لیست",
              icon: <DeleteSVG />,
              onClick: onClickRemovePlaylist,
            }
          : null,
      ]}
    />
  );
};
